var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysis-box"},[_c('div',{staticClass:"analysis-box-title flex-box flex-between flex-items"},[_c('span',[_vm._v("工时分布")])]),_c('div',{staticClass:"analysis-box-content flex-box"})])
}]

export { render, staticRenderFns }